import { render, staticRenderFns } from "./FormSwitch.vue?vue&type=template&id=488ead13&"
import script from "./FormSwitch.vue?vue&type=script&lang=js&"
export * from "./FormSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports